import React from 'react';
import {
  HeaderDetails,
  HeaderTitle,
  Left,
  SubmissionFlowHeaderWrap,
  Right,
  ExitMarkWrapper,
  VersionText
} from '@common/components/SubmissionFlowHeader/styles';
import { ReactSVG } from 'react-svg';
import { useNavigate } from 'react-router';
import { Tooltip } from '@common/components/tooltip/Tooltip';
import { useIsOverflow } from '@hooks/useIsOverflow';
import { globalRoutes } from '@routing/routes';
import { Button } from '@common/components/Button/Button';
import { ButtonTypes } from '@common/components/Button/types';
import EmcLinkPanel from '@common/components/EmcLinkPanel/EmcLinkPanel';


interface ISubmissionFlowHeader {
  title?: string;
  children?: React.ReactNode;
  subTitle?: string;
  docVersion?: number;
  emcUrlTitle?: string;
  emcUrl?: string;
  showQrCode?: boolean;

  onBackClick?: () => void;
  onCloseClick?: () => void;
}

const SubmissionFlowHeader = ({ title, children, subTitle,  docVersion, emcUrl, emcUrlTitle, showQrCode, onBackClick, onCloseClick }: ISubmissionFlowHeader) => {
  const navigate = useNavigate();
  const titleRef = React.useRef<HTMLSpanElement>(null);
  const isTitleOverflow = useIsOverflow(titleRef);

  const handleBackClick = () => {
    onBackClick ? onBackClick() : navigate(-1);
  };

  const handleCloseClick = () => {
    onCloseClick ? onCloseClick() : navigate(globalRoutes.dashboard);
  };

  return (
    <SubmissionFlowHeaderWrap>
      <Left>
        <Button onClick={handleBackClick} text="< Back" type={ButtonTypes.PRIMARY} />
        <HeaderDetails>
          {children}
          <HeaderTitle data-tooltip-id={'submission-flow-header'} data-tooltip-content={title} ref={titleRef}>
            {title}
          </HeaderTitle>
          <Tooltip hidden={!isTitleOverflow} id={'submission-flow-header'} style={{ maxWidth: '30vw' }} />
          <b>{subTitle}</b>
          {docVersion && <VersionText>Version: {docVersion}</VersionText>}
        </HeaderDetails>
      </Left>
      <Right>
        {emcUrl === undefined ? '' : <EmcLinkPanel title={emcUrlTitle ?? ''} emcUrl={emcUrl!} showQrCode={showQrCode}></EmcLinkPanel>}
        <ExitMarkWrapper onClick={handleCloseClick}>
          <ReactSVG src="/icons/exit_mark.svg" />
        </ExitMarkWrapper>
      </Right>
    </SubmissionFlowHeaderWrap>
  );
};

export default SubmissionFlowHeader;
